import styled from 'styled-components';
import { Slider } from 'antd';

export const CustomSlider = styled(Slider)`
  .ant-slider-dot {
    top: -1px;
    width: 10px;
    height: 10px;
  }

  .ant-slider-handle {
    top: 3px;
  }
`;

export const DerivativesBodyWrapper = styled.div`
  padding: 0 15px;
  height: auto;
`;

export const OrderValueInputSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 10px;
  position: relative;
`;
export const PercentageFormWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  background-color: ${(props) => props.theme.COLORS.gray};
  justify-content: center;
  align-items: center;
  border-radius: 5px;
`;
export const QuantityCosts = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
  margin-inline: 5px;
  gap: 3px;
  ::-webkit-scrollbar {
    width: 10px;
    height: 3px;
  }

  ::-webkit-scrollbar-track {
    background-color: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 5px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }
`;
